var map = {
	"../docking-points/docking-points.module": [
		"./src/app/docking-points/docking-points.module.ts",
		"default~docking-points-docking-points-module~docking-stations-docking-stations-module",
		"docking-points-docking-points-module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./bikes/bikes.module": [
		"./src/app/bikes/bikes.module.ts"
	],
	"./customer-dashboard/customer-dashboard.module": [
		"./src/app/customer-dashboard/customer-dashboard.module.ts",
		"customer-dashboard-customer-dashboard-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./docking-stations/docking-stations.module": [
		"./src/app/docking-stations/docking-stations.module.ts",
		"default~docking-points-docking-points-module~docking-stations-docking-stations-module",
		"common",
		"docking-stations-docking-stations-module"
	],
	"./errors/errors.module": [
		"./src/app/errors/errors.module.ts",
		"errors-errors-module"
	],
	"./events/events.module": [
		"./src/app/events/events.module.ts",
		"events-events-module"
	],
	"./info/info.module": [
		"./src/app/info/info.module.ts",
		"info-info-module"
	],
	"./inventory/inventory.module": [
		"./src/app/inventory/inventory.module.ts"
	],
	"./issues/issues.module": [
		"./src/app/issues/issues.module.ts",
		"issues-issues-module"
	],
	"./repair/repair.module": [
		"./src/app/repair/repair.module.ts"
	],
	"./routes/routes.module": [
		"./src/app/routes/routes.module.ts",
		"routes-routes-module"
	],
	"./session-summary/session-summary.module": [
		"./src/app/session-summary/session-summary.module.ts",
		"session-summary-session-summary-module"
	],
	"./sessions/sessions.module": [
		"./src/app/sessions/sessions.module.ts"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"common",
		"users-users-module"
	],
	"./workshop-repair/workshop-repair.module": [
		"./src/app/workshop-repair/workshop-repair.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;